import React, { useEffect, useState } from 'react';
import Banner from '../../components/Banner';
import styles from '../../css/partnerWithUs.module.css';
import partnerWithUs from '../../assets/images/patner-with-us.png';
import bookingEngine from '../../assets/images/booking-engine.png';
import channelManager from '../../assets/images/channel-manager.png';
import cloudPMS from '../../assets/images/cloud-pms.png';
import cloudPOS from '../../assets/images/cloud-pos.png';
import partNer1 from '../../assets/images/partner-1.png';
import partNer2 from '../../assets/images/partner-2.png';
import partNer3 from '../../assets/images/partner-3.png';
import partNer4 from '../../assets/images/partner-4.png';


const PartnerWithUs = () => {
  return (
    <div className="main-container">
      <Banner
        image={partnerWithUs}
        altText="Partner With Us"
        className="partner-with-us-banner"
      >
      </Banner>
  
        <section className={styles.section1}>
          <div className="container">
           <p className="comp-desc">HiveRooms is more than just a hospitality technology solution; it’s now a travel marketplace
              where you can book your accommodations, travel experiences, and events in one platform.</p>
          </div>
        </section>

        <section className={styles.section2}>
            <div className="comp-categories">
                <ul>
                <li><a href="#key-benefits">Key Benefits</a></li>
                <li><a href="#why-partner-with-hiverooms">Why Partner With HiveRooms</a></li>
                <li><a href="#how-it-works">How It Works</a></li>
                </ul>
            </div>
        </section>

        <section id="key-benefits" className={styles.section3}>
            <div className="container">
                <h4 className={styles.heading}>Partner with Us to Revolutionize Travel</h4>
                <p className={styles.subHeading}>No Upfront Cost, Commission-Based, Grow Revenue Through Innovation</p>
                <h5 className={styles.miniHeading}>Become a Partner</h5>
                <h2 className={`title-heading ${styles.tHeading}`}>Key Benefits</h2>
                <div className={styles.cmsBenefits}>
                    <div className={styles.boxes}>
                        <img src={channelManager} alt="Channel Manager" />
                        <h5 className={styles.title}>Channel Manager</h5>
                        <p className={styles.subTitle}>Sync bookings
                            across all OTAs</p>
                    </div>
                    <div className={styles.boxes}>
                        <img src={bookingEngine} alt="Booking Engine" />
                        <h5 className={styles.title}>Booking Engine</h5>
                        <p className={styles.subTitle}>Direct website
                            reservations</p>
                    </div>
                    <div className={styles.boxes}>
                        <img src={cloudPMS} alt="Cloud PMS" />
                        <h5 className={styles.title}>Cloud PMS</h5>
                        <p className={styles.subTitle}>Simplify hotel
                            operations</p>
                    </div>
                    <div className={styles.boxes}>
                        <img src={cloudPOS} alt="Cloud POS" />
                        <h5 className={styles.title}>Cloud POS</h5>
                        <p className={styles.subTitle}>Manage F&B and
                            Spa</p>
                    </div>
                </div>
            </div>
        </section>

        <section id="why-partner-with-hiverooms" className={styles.section4}>
            <div className="container">
                <h2 className={`title-heading ${styles.tHeading}`}>Why Partner With HiveRooms</h2>
                <div className={styles.partNers}>
                    <div className={styles.boxes}>
                        <img src={partNer1} alt="Partner" />
                        <p className={styles.desc}>No Up front Costs, Commission-Based Only</p>
                    </div>
                    <div className={styles.boxes}>
                        <img src={partNer2} alt="Partner" />
                        <p className={styles.desc}>Designed for hotels, resorts & accommodations</p>
                    </div>
                    <div className={styles.boxes}>
                        <img src={partNer3} alt="Partner" />
                        <p className={styles.desc}>Cloud-based & easytouse</p>
                    </div>
                    <div className={styles.boxes}>
                        <img src={partNer4} alt="Partner" />
                        <p className={styles.desc}>Proven revenue growth focus</p>
                    </div>
                </div>
            </div>
        </section>

        <section id="how-it-works" className={styles.section5}>
            <div className="container">
                <h2 className={`title-heading ${styles.tHeading}`}>How It Works</h2>
                <div className={styles.stepsWrapper}>
                    <div className={styles.step}>
                        <h3>Sign Up</h3>
                        <p>Simple Inquiry Process</p>
                    </div>
                    <span className={styles.arrow}>→</span>

                    <div className={styles.step}>
                        <h3>Meeting</h3>
                        <p>Discussion of Partnership and Contracts</p>
                    </div>
                    <span className={styles.arrow}>→</span>

                    <div className={styles.step}>
                        <h3>Integration</h3>
                        <p>We set up and connect your systems</p>
                    </div>
                    <span className={styles.arrow}>→</span>

                    <div className={styles.step}>
                        <h3>Go Live</h3>
                        <p>Start accepting seamless bookings</p>
                    </div>
                    <span className={styles.arrow}>→</span>

                    <div className={styles.step}>
                        <h3>Support</h3>
                        <p>Continuous assistance for your property</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
  );
};

export default PartnerWithUs;